var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAccordion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#EBF1FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24213 16.7706C9.39721 16.9175 9.60751 17 9.8268 17C10.0461 17 10.2564 16.9175 10.4115 16.7706L14.505 12.8915L18.5985 16.7706C18.7545 16.9133 18.9634 16.9923 19.1802 16.9905C19.397 16.9887 19.6045 16.9063 19.7578 16.761C19.9111 16.6157 19.9981 16.4192 20 16.2137C20.0019 16.0082 19.9185 15.8103 19.7679 15.6625L15.0897 11.2294C14.9346 11.0825 14.7243 11 14.505 11C14.2857 11 14.0754 11.0825 13.9203 11.2294L9.24213 15.6625C9.08709 15.8094 9 16.0087 9 16.2165C9 16.4243 9.08709 16.6236 9.24213 16.7706Z",
    fill: "#0C2556"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccordion);
export default __webpack_public_path__ + "static/media/iconAccordion.713e37331db49acd158053ff85e7a277.svg";
export { ForwardRef as ReactComponent };